import React from 'react';
import { Link } from 'react-router-dom';
import './Resources.css';

function Resources() {
  const guides = [
    {
      id: 1,
      title: 'Getting Started Guide',
      description: 'Launch fast with the exact setup checklist we use for service businesses moving from offline to online.',
      path: '/resources/getting-started',
      category: 'Learning',
      readTime: '8 min read'
    },
    {
      id: 2,
      title: 'Marketing Strategies for 2025',
      description: 'Simple campaigns and channel strategy to bring in qualified leads without wasting ad budget.',
      path: '/resources/marketing-strategies',
      category: 'Marketing',
      readTime: '12 min read'
    },
    {
      id: 3,
      title: 'SEO for Your Business',
      description: 'Rank for local buyer searches and convert search traffic into calls, bookings, and form submissions.',
      path: '/resources/seo-guide',
      category: 'SEO',
      readTime: '10 min read'
    },
    {
      id: 4,
      title: 'Portfolio Showcase',
      description: 'Browse live client launches in a premium visual gallery that hides any site that is offline.',
      path: '/portfolio',
      category: 'Portfolio',
      readTime: 'Live page'
    },
    {
      id: 5,
      title: 'Case Studies: Real Success Stories',
      description: 'Real before-and-after outcomes from businesses we helped scale with cleaner systems and better web presence.',
      path: '/resources/case-studies',
      category: 'Success Stories',
      readTime: '15 min read'
    },
    {
      id: 6,
      title: 'Growth Tips from Our Top Customers',
      description: 'High-impact quick wins you can apply this week to increase response rates and repeat business.',
      path: '/resources/growth-tips',
      category: 'Tips',
      readTime: '5 min read'
    },
    {
      id: 7,
      title: 'Best Practices Playbook',
      description: 'Execution standards for websites, lead handling, and follow-up so every customer touchpoint feels premium.',
      path: '/resources/best-practices',
      category: 'Best Practices',
      readTime: '9 min read'
    }
  ];

  return (
    <div className="resources-container">
      {/* Hero Section */}
      <section className="resources-hero">
        <div className="hero-content">
          <span className="resources-eyebrow">Versa Launch Resource Hub</span>
          <h1>Playbooks for local brands that want real growth</h1>
          <p>Actionable guides, case studies, and proven systems to help your business attract more leads and close more revenue online.</p>
          <div className="hero-pills">
            <span>Website Growth</span>
            <span>Local SEO</span>
            <span>Lead Conversion</span>
          </div>
        </div>
        <img src="/images/Overlookiung-PC.jpg" alt="Resources" className="hero-image" />
      </section>

      {/* Featured Guides */}
      <section className="featured-section">
        <div className="featured-header">
          <h2>Featured resources</h2>
          <p>Clear reads. Practical next steps. No fluff.</p>
        </div>
        
        <div className="guides-grid">
          {guides.map((guide) => (
            <Link key={guide.id} to={guide.path} className="guide-card">
              <div className="guide-header">
                <span className="guide-category">{guide.category}</span>
                <span className="guide-time">{guide.readTime}</span>
              </div>
              <h3>{guide.title}</h3>
              <p>{guide.description}</p>
              <div className="guide-footer">
                <span className="read-more">Read More →</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="resources-cta">
        <h2>Want us to implement this for you?</h2>
        <p>Use these resources as a roadmap, then let Versa Launch build and optimize the system end-to-end.</p>
        <div className="cta-buttons">
          <Link to="/features" className="cta-btn-primary">Explore Features</Link>
          <Link to="/plans" className="cta-btn-secondary">View Pricing</Link>
        </div>
      </section>
    </div>
  );
}

export default Resources;
